import { ConfigRoutes } from "@shared/models/general/utils.interface";

const pathModulo: string = '/rendiciones/'

interface AccesosRendiciones {
  REGISTRO_DEVOLUCIONES: ConfigRoutes;

  ENTREGA_REQUERIMIENTO: ConfigRoutes;
  ENTREGA_RENDICIONES: ConfigRoutes;
  ENTREGA_REPORTES: ConfigRoutes;

  REGISTRO_COMPRAS_REGISTRO: ConfigRoutes;
}

interface ModuloRendiciones {
  ID: number,
  ACCESOS: AccesosRendiciones
}

export const MODULO_RENDICIONES: ModuloRendiciones = {
  ID: 35,
  ACCESOS: {
    REGISTRO_DEVOLUCIONES: { TITLE: 'Registro de devoluciones', ACCESS: 401, PATH_MODULE: pathModulo, ROUTE: 'registro-devoluciones', DESCRI: 'Rendiciones - Consulta de registro de devoluciones' },

    ENTREGA_REQUERIMIENTO: { TITLE: 'Requerimiento de rendiciones', ACCESS: 701, PATH_MODULE: pathModulo, ROUTE: 'requerimiento-rendiciones', DESCRI: 'Rendiciones - Consulta de requerimiento de rendiciones' },
    ENTREGA_RENDICIONES: { TITLE: 'Rendiciones', ACCESS: 702, PATH_MODULE: pathModulo, ROUTE: 'rendiciones', DESCRI: 'Rendiciones - Consulta de rendiciones' },
    ENTREGA_REPORTES: { TITLE: 'Reportes', ACCESS: 702, PATH_MODULE: `${pathModulo}reportes/`, ROUTE: 'seguimiento-rendiciones', DESCRI: 'Rendiciones - Reportes' },

    REGISTRO_COMPRAS_REGISTRO: { TITLE: "Contabilización de documentos de proveedor", ACCESS: 205, PATH_MODULE: pathModulo, ROUTE: `registro-compras/nuevo`, DESCRI: 'Registro de compras - Nuevo' },
  }
}

const MENU_KEYS_BUSQUEDA = ['REGISTRO_DEVOLUCIONES', 'ENTREGA_REQUERIMIENTO', 'ENTREGA_RENDICIONES', 'ENTREGA_REPORTES'] as const

export const MODULO_RENDICIONES_BUSQUEDA = Object.entries(MODULO_RENDICIONES.ACCESOS)
  .filter((item): item is [typeof MENU_KEYS_BUSQUEDA[number], ConfigRoutes] => (MENU_KEYS_BUSQUEDA as readonly string[]).includes(item[0]))
